export default {
    url: '',
    template: '<survey-public-survey form-submission="vm.formSubmission" survey-group="vm.surveyGroup" company="vm.company"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form,anySurveyGroupParticipant,user,user.company' }).$promise;
        },
        company (CompanyResource, formSubmission) {
            return CompanyResource.publicView({ id: formSubmission.companyId, expand: 'companySurveyI18ns' }).$promise;
        }
    },
    controller ($rootScope, $state, formSubmission, surveyGroup, company, WindowConfirmService, CompanyService) {
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }

        this.formSubmission = formSubmission;
        this.surveyGroup = surveyGroup;
        this.company = company;
        $rootScope.formSubmission = formSubmission;
        $rootScope.$emit('survey.loaded');

        // ask confirmation if user refresh
        WindowConfirmService.activate();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/survey/survey/do/index.js